import { Parameter } from './../../../../@core/interfaces/common/parameter';
import { Observable } from 'rxjs';
import { Binary } from '@angular/compiler';
import { DecimalPipe } from '@angular/common';

export interface BloodIndentRequestDetailsParameter extends Parameter {
    searchTerm: number;
    orderBy: string;
}

export interface BloodIndentRequestDetails {

    blIndentMstId?:number;
    blIndentTrackId?:number;
    blRowId:number;
    blBloodId:number;
    blPriority:string;
    blIndentQty:number;
    blApprovalQty:number;
    blIndentItemStatus:string;
    blRequesterTenantId:string;
    blRequesterBranchId:string;
    blRequesterDepartmentId:string;
    createdBy:string;
    createdDate:any;
    updatedBy:string;
    updatedDate:string;
    branchId: string;
    tenantId: string;
}


export abstract class BloodIndentRequestDetailsData {
  abstract list(url: string): Observable<any[]>;
  abstract searchList(url: string,data:any): Observable<any>;
  abstract create(url: string,data: any): Observable<any>;
  abstract update(url: string,data: any): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
